import { z } from "zod";

export const consultationLinkResponseSchema = z.object({
  auto_promote: z.boolean(),
  code: z.string(),
  created_at: z.string(),
  default_consultation_fee: z.number(),
  default_primary_provider: z
    .object({
      id: z.uuid(),
      full_name: z.string(),
    })
    .nullable(),
  description: z.string().nullable(),
  id: z.string(),
  is_active: z.boolean(),
  label: z.string(),
  scheduling_included: z.boolean(),
  updated_at: z.string(),
});

export const upsertConsultationLinkRequestSchema = z.object({
  organization_id: z.string().min(1, "Organization Id is required"),
  link_id: z.string().optional(),
  label: z
    .string()
    .min(1, "Name is required")
    .max(100, "Name must be at most 100 characters long"),
  description: z
    .string()
    .max(200, "Description must be at most 200 characters long")
    .nullable(),
  default_primary_provider_id: z.preprocess(
    (val) => (val === "" ? null : val),
    z.uuid().nullable(),
  ),
  default_consultation_fee: z
    .number()
    .nonnegative("Fee must be zero or a positive number"),
  auto_promote: z.boolean({
    error: "Auto promote option is required",
  }),
  scheduling_included: z.boolean({
    error: "Scheduling included option is required",
  }),
});
